// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__E_eSW","containerItemsCenter":"Skeleton_containerItemsCenter__2sAcQ"};